import React, { useContext, useMemo } from 'react';

export enum EmptyStateSize {
  largeSurface = 'largeSurface',
  mediumSurface = 'mediumSurface',
  mediumMenu = 'mediumMenu',
  smallMenu = 'smallMenu',
}

export interface EmptyStateSizeProps {
  size: EmptyStateSize;
}

export const EmptyStateSizeContext = React.createContext<EmptyStateSizeProps>({ size: EmptyStateSize.largeSurface });

export const EmptyStateSizeProvider: React.FC<React.PropsWithChildren<EmptyStateSizeProps>> = ({ size, children }) => {
  const value = useMemo(() => ({ size }), [size]);

  return (
    <EmptyStateSizeContext.Provider value={value}>
      {children}
    </EmptyStateSizeContext.Provider>
  );
};

export const useEmptyStateSizeContext = (): EmptyStateSizeProps => {
  const context = useContext(EmptyStateSizeContext);

  if (!context) {
    throw new Error('useEmptyStateContext must be used within a EmptyStateProvider');
  }

  return context;
};

export function withSizeContext<TProps>(Component: React.FC<TProps>) {
  const EmptyState: React.FC<TProps & EmptyStateSizeProps> = ({ size, ...rest }) => (
    <EmptyStateSizeProvider size={size}>
      <Component {...(rest as any)} />
    </EmptyStateSizeProvider>
  );

  return EmptyState;
}
